import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_5: FaireProductEntity = {
  token: "atc_nf_chunks_5",
  type: "product",
  name: "Box Claw in Butterfly",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/products/Claw-Butterfly-Clear-WBG-web-2.jpg?v=1664585293",
  priceDollars: 20.95,
  msrpDollars: 42,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
